import type { SVGProps } from "react";

export default function PhotoIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 15.0001C12.3012 15.0001 14.1667 13.1346 14.1667 10.8334C14.1667 8.53223 12.3012 6.66673 10 6.66673C7.69885 6.66673 5.83337 8.53223 5.83337 10.8334C5.83337 13.1346 7.69885 15.0001 10 15.0001ZM10 13.3393C8.61603 13.3393 7.49412 12.2174 7.49412 10.8334C7.49412 9.4494 8.61603 8.32748 10 8.32748C11.384 8.32748 12.5059 9.4494 12.5059 10.8334C12.5059 12.2174 11.384 13.3393 10 13.3393Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.96799 1.66673C6.82082 1.66673 5.82087 2.44747 5.54263 3.56039L5.18272 5.00007H3.33337C1.95266 5.00007 0.833367 6.11936 0.833367 7.50007V15.8334C0.833367 17.2141 1.95266 18.3334 3.33337 18.3334H16.6667C18.0474 18.3334 19.1667 17.2141 19.1667 15.8334V7.50007C19.1667 6.11936 18.0474 5.00007 16.6667 5.00007H14.8174L14.4574 3.56039C14.1792 2.44747 13.1793 1.66673 12.032 1.66673H7.96799ZM7.15954 3.96462C7.25228 3.59365 7.5856 3.3334 7.96799 3.3334H12.032C12.4144 3.3334 12.7478 3.59365 12.8405 3.96462L13.2004 5.40429C13.3859 6.14624 14.0525 6.66673 14.8174 6.66673H16.6667C17.1269 6.66673 17.5 7.03983 17.5 7.50007V15.8334C17.5 16.2936 17.1269 16.6667 16.6667 16.6667H3.33337C2.87313 16.6667 2.50003 16.2936 2.50003 15.8334V7.50007C2.50003 7.03983 2.87313 6.66673 3.33337 6.66673H5.18272C5.9475 6.66673 6.61413 6.14624 6.79962 5.40429L7.15954 3.96462Z"
      />
    </svg>
  );
}
